import React from "react";
import ReactDOM from "react-dom/client";
//styles
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/style.scss";
//components

//import LandingPage from "./components/LandingPage";
import App from "./router/AppRouter";
//-----
const root = ReactDOM.createRoot(document.getElementById("root"));

const jsx = <App />;

root.render(jsx);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
